import { graphql } from 'app/generated/gql'
import { gqlQuery } from 'app/lib/graphqlClient'

const BLOCKOUT_NOTES_QUERY = graphql(`
  query BlockoutNotes($locationId: ID!) {
    blockoutNotes(locationId: $locationId) {
      note
    }
  }
`)

/**
 * Fetch blockout notes for a location via GraphQL.
 * Compatible with ComboMultiSelectAsync's fetchFn prop.
 */
export async function fetchBlockoutNotes(params: Record<string, string>): Promise<string[]> {
  const locationId = params.locationId
  if (!locationId) return []
  const result = await gqlQuery<{ blockoutNotes: { note: string }[] }>(BLOCKOUT_NOTES_QUERY, { locationId })
  return (result.data?.blockoutNotes ?? []).map((b) => b.note)
}
